import Vue from 'vue'

const state = {
  stage: 0,
  quantity: 0,
  maxQuantities: {}, // Required for list ordering
  totalInStock: {},
  debits: {},
  muted: {}, // {inventoryID: true}
  freeze: {},
  batchSelectionOrder: 0,
  /* an exact copy of current inventory per item,
  necessary because polling inventory for each build item
  after each keypress on quantity change is an expensive
  computation */
  inventory: {}
}

const mutations = {
  RESET (state) {
    state.stage = 0
    state.quantity = 0
    state.maxQuantities = {}
    state.totalInStock = {}
    state.debits = {}
    state.muted = {}
    state.freeze = {}
    state.inventory = {}
  },
  SET_MAX_QUANTITY (state, {buildID, quantity}) {
    Vue.set(state.maxQuantities, buildID, quantity)
  },
  SET_QUANTITY (state, quantity) {
    state.quantity = quantity
  },
  SET_TOTAL_IN_STOCK (state, {buildID, totalInStock}) {
    Vue.set(state.totalInStock, buildID, totalInStock)
  },
  SET_DEBIT (state, {inventoryItemID, debit}) {
    Vue.set(state.debits, inventoryItemID, debit)
  },
  MUTE (state, {inventoryItemID, mute}) {
    Vue.set(state.muted, inventoryItemID, mute)
    if (mute) {
      state.debits[inventoryItemID] = 0
    }
  },
  FREEZE (state, {inventoryItemID, freeze}) {
    Vue.set(state.freeze, inventoryItemID, freeze)
  },
  SET_INVENTORY (state, {inventoryItemID, inventory}) {
    Vue.set(state.inventory, inventoryItemID, inventory)
  },
  SET_BATCH_SELECTION_ORDER (state, val) {
    state.batchSelectionOrder = val
  },
  SET_STAGE (state, val) {
    state.stage = val
  }
}

const actions = {
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
